import { createFileRoute } from "@tanstack/react-router"
import { lazyImportRouteComponent } from "../../../../utils/lazyImportRouteComponent"
import { tab } from "./-components/PersonsTabs"

export const Route = createFileRoute("/app/contacts/$id/")({
  component: lazyImportRouteComponent(
    () => import("./-components/PersonsTabs"),
    "PersonsTabs"
  ),

  validateSearch: (search: {
    tab: tab
    reminderDetailOpened?: boolean
    reminderId?: number
  }) => ({
    ...search,
    tab: search.tab || "start",
  }),
})
